<style>
  .container{
    width: 100%;
    margin-bottom: 20px;
  }
  .navigation{
    padding: 20px 0 20px 10px;
    background-color: #fff;
    margin-bottom: 20px;
    border-bottom: 1px solid #d3dce6;
  }
  .navigation .el-breadcrumb{
    font-size: 16px!important;
  }
</style>
<template>
  <div class="module00299303 container" v-loading="loading">
    <div class="api-defined-navigation">
      <div class="navigation">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>授权用户维护</el-breadcrumb-item>
          <template v-if="!isShow">
            <el-breadcrumb-item v-if="operationType === 'detail'">查看授权用户信息</el-breadcrumb-item>
            <el-breadcrumb-item v-if="operationType === 'add'">新增授权用户信息</el-breadcrumb-item>
            <el-breadcrumb-item v-if="operationType === 'edit'">编辑授权用户信息</el-breadcrumb-item>
          </template>
        </el-breadcrumb>
      </div>
    </div>
    <template v-if="isShow">
      <el-card>
        <div class="api-defined-body">
          <show-table
            ref = 'showtable'
            :queryobj = 'queryObj'
            :queryparam = 'queryParam'
            :showopertbtn = 'showType'
            @delItem = 'delUser'
            @editItem="toDetails">
            <el-button slot='add' type="primary" icon="plus" size="small" @click="addNewUser">新增用户</el-button>
          </show-table>
        </div>
      </el-card>
    </template>
    <template v-else>
      <authorize-useradd @goback="showMain" :operation="operationType" :rowdatas="rowDatas" @navagationtype="navType"></authorize-useradd>
    </template>

  </div>
</template>

<script>
  import  util from '../../../util.js'
  import authorizeUserAdd from './authorizeUserAdd.vue'
  import {bizQueryBatchExecute} from '../../../vuex/actions'
  import {sessionUser} from '../../../vuex/getters'
  export default{
    components:{
      'authorize-useradd':authorizeUserAdd
    },
    vuex: {
      getters: {
        sessionUser
      },
      actions: {
        bizQueryBatchExecute
      }
    },
    data(){
      return{
        isShow:true,
        operationType:'',
        loading: false,
        rowDatas:{},
        queryObj: {
          queryName: 'OAuthUsers',
          AppID: '',
          AppKey: '',
          displayLabel: '用户AppId/用户名称',
        },
        queryParam: 'AppID',
        showType: {
          edit: true,
          del: true,
          defined: false,
        }
      }
    },
    methods: {
      toDetails(val){
        this.isShow = false
        this.operationType = 'detail'
        this.rowDatas = val
      },
      delUser (data) {
        let params = {
          dataList_0: [{
            BusinessID: 'OAuthUserDel',
            OperName: this.sessionUser.userName,
            Operator: this.sessionUser.userId,
            ModuleID: this.$route.params.moduleID || '399302',
            ActionNO: 'OAuthUserDel',
            PaperNO: '',
            //删除需要的参数
            AppID: data.AppID,
            LastUpdateTime: data.LastUpdateTime,
            Old_LastUpdateTime: data.LastUpdateTime,
          }]
        }
        this.$confirm(`确认要删除当前授权用户【${data.AppID}】吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          this.bizQueryBatchExecute(params, (res) => {
            this.loading = false
            if (res.isValid && res.data.isValid){
              util.success(this, `已删除授权用户【${data.AppID}】`)
              this.$refs.showtable.searchData()
            }else{
              util.error(this, '删除失败')
            }
          })
        }).catch(() => {
          console.log('cancel')
        })
      },
      addNewUser () {
        this.isShow = false
        this.rowDatas = {AppID: ''}
        this.operationType = 'add'
      },
      showMain(){
        this.isShow = true
      },
      navType(val){
        this.operationType=val;
        console.log('this.operationType',this.operationType);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// 00399302.vue?6c418614